// @flow
import { takeEvery, call } from 'redux-saga/effects';

import TagManager from 'react-gtm-module';

import { DATA_LAYER_NAME } from '@lib/constants';

import { EXTERNAL_FLOW_START } from './constants';

import type { Action } from '../types';

export function* externalFlowRedirection(): Generator<Function, void, any> {
  yield call(TagManager.dataLayer, {
    dataLayerName: DATA_LAYER_NAME,
    dataLayer: {
      event: 'BookAppointment',
      funnelId: 'MainFlow',
      funnelVariant: 'a'
    }
  });
}

export function* homeFlow(action: Action): Generator<Function, void, Action> {
  switch (action.type) {
    case EXTERNAL_FLOW_START:
      yield call(externalFlowRedirection, action);
      break;
    default:
      break;
  }
}

function* homeWatcher(): Generator<Function, void, Action> {
  yield takeEvery([EXTERNAL_FLOW_START], homeFlow);
}

export default homeWatcher;
